
export default {
  name: 'InputIcon',
  props: ['prependIcon', 'appendIcon', 'placeholder', 'type', 'id', 'name', 'classes',
    'disabled', 'autocomplete', 'autofocus', 'value', 'min', 'max', 'textRight'],
  data () {
    return {
      isFocused: false
    }
  },
  methods: {
    handleInput (event) {
      this.$emit('input', event.target.value)
    },
    handleFocus (event) {
      this.isFocused = true
      this.$emit('focus', event)
    },
    handleBlur (event) {
      this.isFocused = false
      this.$emit('blur', event)
    }
  },
}
